import React from 'react';
import { StyledDiv } from '../../../Theme/CommonStyled';
import { StyledNavigationLink } from './style';
import waze from '../../../Assets/images/Waze.svg';
import googleMap from '../../../Assets/images/Maps.svg';
import Modal from '../Modal';
import {
  ClubLinkBranchInfoType,
  ContactUsViewModelType
} from '../../../Types/landing.type';

type NavigationModalType = {
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
  branchData: ContactUsViewModelType;
};
const NavigationModal: React.FC<NavigationModalType> = ({
  openModal,
  setOpenModal,
  branchData
}) => {
  return (
    <Modal open={openModal} setOpen={setOpenModal} background="transparent">
      <StyledDiv
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column">
        {branchData?.WazeLink && (
          <StyledDiv textAlign="center" mb={9} color="secondaryButtonText">
            <StyledNavigationLink href={branchData?.WazeLink} target={'-blank'}>
              <img src={waze} alt="waze" />
            </StyledNavigationLink>
            Waze
          </StyledDiv>
        )}
        {branchData?.GoogleLink && (
          <StyledDiv textAlign="center" mb={9} color="secondaryButtonText">
            <StyledNavigationLink
              href={branchData?.GoogleLink}
              target={'-blank'}>
              <img src={googleMap} alt="map" />
            </StyledNavigationLink>
            GOOGLE
          </StyledDiv>
        )}
      </StyledDiv>
    </Modal>
  );
};

export default NavigationModal;
